<template>
  <v-layout row class="align-center layout px-4 pt-4 app--page-header">
    <div class="page-header-left">
      <h3 class="pr-3">{{title}}</h3>
    </div>
    <v-icon larg>home</v-icon>
    <v-breadcrumbs :items="breadcrumbs">
      <template v-slot:divider>
        <v-icon>chevron_right</v-icon>
      </template>
    </v-breadcrumbs>
    <v-spacer></v-spacer>
  </v-layout>
</template>

<script>
import menu from '@/api/menu_eureka';
export default {
  data () {
    return {
      title: '',
    };
  },
  computed: {
    breadcrumbs: function () {
      let breadcrumbs = [];
      
      menu.forEach(item => {
        if (item.items) {
          let child = item.items.find(i => {
            return i.component === this.$route.name;
          });
          if (child) {
            let menu = {};
            menu.text = item.title;
            menu.disabled = false;
            this.title = item.title;
            breadcrumbs.push(menu);
            // breadcrumbs.push(child.title);
            this.title = child.title;
          }
        } else {
          if (item.name === this.$route.name) {
            let menu = {};
            menu.text = item.title;
            menu.disabled = false;
            this.title = item.title;
            breadcrumbs.push(menu);
          }
        } 
      });
      return breadcrumbs;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/PageHeader.vue